import type { Component } from './types';

import { useState } from 'react';

import { Loader } from '../loader';
import { PageLoaderContext } from './context';

export const PageLoaderProvider: Component = ({ children }) => {
  const [isPageLoading, setIsPageLoading] = useState(false);

  return (
    <PageLoaderContext value={{ isPageLoading, setIsPageLoading }}>
      {children}
      {
        isPageLoading && (
          <Loader blockPage size={56} />
        )
      }
    </PageLoaderContext>
  );
};
